export const GOOGLE_MAPS_SCRIPT_ID = "google-maps-js-api";
export const GOOGLE_MAPS_JS_API_BASE_URL =
  "https://maps.googleapis.com/maps/api/js";
export const GOOGLE_ADDRESS_VALIDATION_BASE_URL =
  "https://addressvalidation.googleapis.com/v1:validateAddress";
